import script from "./SaleDocumentType.vue?vue&type=script&setup=true&lang=js"
export * from "./SaleDocumentType.vue?vue&type=script&setup=true&lang=js"

import "./SaleDocumentType.vue?vue&type=style&index=0&id=f125549e&lang=css"

const __exports__ = script;

export default __exports__